import { useTranslations } from 'next-intl'

import {
  Text,
  Center,
  useColorModeValue,
  Button,
  Modal,
  ModalOverlay,
  ModalBody,
  ModalContent,
  ModalCloseButton,
  HStack,
} from '@chakra-ui/react'

type ConfirmationModalProps = {
  isOpen: boolean
  onClose: () => void
  confirmationFunction: () => void
  title: string
  description: string
  loading: boolean
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  isOpen,
  onClose,
  confirmationFunction,
  title,
  description,
  loading,
}: ConfirmationModalProps) => {
  const t = useTranslations()

  return (
    <>
      <Modal
        isCentered
        onClose={onClose}
        isOpen={isOpen}
        motionPreset="slideInBottom"
        size="xl"
      >
        <ModalOverlay />
        <ModalContent>
          <ModalCloseButton />
          <ModalBody
            py="5"
            bg={useColorModeValue('gray.200', 'gray.800')}
            rounded={'md'}
          >
            <Center display={'flex'} flexDirection={'column'}>
              <Text
                fontSize="md"
                fontWeight="600"
                color={useColorModeValue('gray.800', 'gray.200')}
                mb="2"
              >
                {title}
              </Text>
              <Text
                fontSize="md"
                color={useColorModeValue('gray.500', 'gray.200')}
                mb="2"
              >
                {description}
              </Text>
              <HStack justify={'center'} align={'center'} pt={4}>
                <Button
                  colorScheme="brand"
                  size="sm"
                  isLoading={loading}
                  onClick={() => {
                    confirmationFunction()
                  }}
                >
                  {t('common.confirm')}
                </Button>
                <Button
                  size="sm"
                  variant="outline"
                  onClick={onClose}
                  color={useColorModeValue('gray.800', 'gray.200')}
                >
                  {t('buttons.cancel')}
                </Button>
              </HStack>
            </Center>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  )
}

export default ConfirmationModal
